const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
class CreditCardContractModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `credit-card-contract-module ${cssVariableKey}`);

    this.contentHash = {};
    this.typingIndicator = null;
  }

  handle(type, value) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleTypingOnClick(component) {
    if(!component) {
      return;
    }
    //handle click
    let buttons;
    const elToAttach = component._option._element.getELM();

    if(component._data && component._data.format === 'creditcard') {
      buttons = elToAttach.getElementsByClassName('continue-button');
    }
    else if(component._option && component._option._element && component._option._element.getELM) {
      buttons = elToAttach.getElementsByClassName('option');
    }

    if(!buttons) {
      return;
    }

    const addTyping = () => {
      this.parent && this.parent.showTyping && this.parent.showTyping();
    };

    for (const button of buttons) { 
      button.addEventListener("click", addTyping, false);
    }
  }

  mapFormat(value) {
    const questionOrCCInput = value.values;
    const ccParams = { data: {} };

    if (questionOrCCInput.name && questionOrCCInput.number && questionOrCCInput.cvc) {
      
      for (let p in questionOrCCInput) {
        ccParams.data[p] = questionOrCCInput[p];
      }

      ccParams.data.format = "creditcard";

      const component = new Block(ccParams);

      this.handleTypingOnClick(component);

      return component;
    }

    ccParams.data = questionOrCCInput;
    const component = new Block(ccParams);

    this.handleTypingOnClick(component);

    return component;
  }
  
  handleOnMessage(value) {
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      
      if(this.contentHash[identifier]) {
        const question = this.contentHash[identifier][1];
        question.updateAnswer(value.values, this.clearAfterId.bind(this));

        if(question && question._data && question._data.id && 
          (question._data.id.endsWith('creditcard-contract/0') || question._data.id.endsWith('creditcard-contract/2'))){
            this.parent && this.parent.showTyping && this.parent.showTyping();
        }
      }    
    } else if (!this.contentHash[identifier]) {

      component = this.mapFormat(value);

      if(identifier.split('/').pop() == 0 && Object.keys(this.contentHash).length > 0){
        this.reset();
      }

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    } else {
      component = this.contentHash[identifier][1];
      
      if (value.values && value.values.error) {

        if(component._option._element.handleOnError) {
          component._option._element.handleOnError(value.values.error);
        }
        else if(value.values.format === 'email') {
          component._option._element.elements.el.classList.add('invalid');
        }
      }
      else if(identifier.split('/').pop() == 0 && Object.keys(this.contentHash).length > 0){
        this.reset();
        component = this.mapFormat(value);
        this.contentHash[identifier] = [0, component];
      }
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  reset() {
    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch && ch.length) {
        this.elContainer.removeELM(ch[1]);
      }
    });
    this.contentHash = {};
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
    // AR: why is this needed
    // this.parent &&
    //   this.parent.clearAfterId &&
    //   this.parent.clearAfterId(this.value.id);
  }
  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = CreditCardContractModule;
